export const clothingSizesArray = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '0',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  'one size',
];

export const CLOTHING_SIZES = [
  {
    value: 'XXS',
    label: 'XXS',
  },
  {
    value: 'XS',
    label: 'XS',
  },
  {
    value: 'S',
    label: 'S',
  },
  {
    value: 'M',
    label: 'M',
  },
  {
    value: 'L',
    label: 'L',
  },
  {
    value: 'XL',
    label: 'XL',
  },
  {
    value: 'XXL',
    label: 'XXL',
  },
  {
    value: 'US0',
    label: 'US 0',
  },
  {
    value: 'US2',
    label: 'US 2',
  },
  {
    value: 'US4',
    label: 'US 4',
  },
  {
    value: 'US6',
    label: 'US 6',
  },
  {
    value: 'US8',
    label: 'US 8',
  },
  {
    value: 'US10',
    label: 'US 10',
  },
  {
    value: 'US12',
    label: 'US 12',
  },
  {
    value: 'US14',
    label: 'US 14',
  },
  {
    value: 'US16',
    label: 'US 16',
  },
  {
    value: 'one-size',
    label: 'one size',
  },
];

export const shoeSizesArray = ['6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11'];

export const SHOE_SIZES = [
  {
    value: 'shoe-size-us-5',
    label: 'US 5',
  },
  {
    value: 'shoe-size-us-5_5',
    label: 'US 5.5',
  },
  {
    value: 'shoe-size-us-6',
    label: 'US 6',
  },
  {
    value: 'shoe-size-us-6_5',
    label: 'US 6.5',
  },
  {
    value: 'shoe-size-us-7',
    label: 'US 7',
  },
  {
    value: 'shoe-size-us-7_5',
    label: 'US 7.5',
  },
  {
    value: 'shoe-size-us-8',
    label: 'US 8',
  },
  {
    value: 'shoe-size-us-8_5',
    label: 'US 8.5',
  },
  {
    value: 'shoe-size-us-9',
    label: 'US 9',
  },
  {
    value: 'shoe-size-us-9_5',
    label: 'US 9.5',
  },
  {
    value: 'shoe-size-us-10',
    label: 'US 10',
  },
  {
    value: 'shoe-size-us-10_5',
    label: 'US 10.5',
  },
  {
    value: 'shoe-size-us-11',
    label: 'US 11',
  },
];

const formatClothingSize = size => {
  const found = CLOTHING_SIZES.find(item => item.label === size);
  return found ? found.value : size.replace(/\s/g, '');
};

const formatShoeSize = size => {
  const found = SHOE_SIZES.find(item => item.label === size);
  return found
    ? found.value
    : `shoe-size-${size
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/\./g, '_')}`;
};

export const getFormattedValue = (size, category) => {
  switch (category) {
    case 'clothing':
      return formatClothingSize(size);

    case 'shoes':
      return formatShoeSize(size);

    default:
      return size;
  }
};
